// TODO: Import React module
import * as React from 'react';
import { useLocation } from 'react-router-dom';

// TODO: Import MUI module;

// TODO: Import MUI icon;

// TODO: Import custom component

export default function ScrollTo() {
    // TODO: Define useContext
    const { pathname } = useLocation();
    const { hash } = useLocation();

    // TODO: Define variable

    // TODO: Define event
    React.useEffect(() => {
        if (hash) {
            document.getElementById(hash.substring(1)).scrollIntoView();
        } else {
            window.scrollTo(0, 0);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, hash]);

    // TODO: Define function

    // TODO: Return component
}